import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayAlertsApiMeta } from "../apiMeta";
import {
  type AlertsByRegionIDInput,
  alertsByRegionIDInputSchema,
} from "./shared/highwayAlerts.input";
import { type Alert, alertSchema } from "./shared/highwayAlerts.output";

/**
 * Metadata for the fetchAlertsByRegionId endpoint
 */
export const alertsByRegionIdMeta = {
  functionName: "fetchAlertsByRegionId",
  endpoint: "/getAlertsByRegionIDAsJson?RegionID={RegionID}",
  inputSchema: alertsByRegionIDInputSchema,
  outputSchema: alertSchema.array(),
  sampleParams: { RegionID: 4 },
  endpointDescription: "List highway alerts filtered by WSDOT region ID.",
} satisfies EndpointMeta<AlertsByRegionIDInput, Alert[]>;

const { fetch, useHook } = createFetchAndHook<AlertsByRegionIDInput, Alert[]>({
  api: wsdotHighwayAlertsApiMeta,
  endpoint: alertsByRegionIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/highwayAlerts.endpoints").highwayAlertsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving highway alerts filtered by WSDOT region ID
 */
export const fetchAlertsByRegionId: FetchFactory<
  AlertsByRegionIDInput,
  Alert[]
> = fetch;

/**
 * React Query hook for retrieving highway alerts filtered by WSDOT region ID
 */
export const useAlertsByRegionId: HookFactory<AlertsByRegionIDInput, Alert[]> =
  useHook;
